import React, { useContext, useMemo } from 'react'
import { StarCount } from '@usap/widgets'
import { Box, ResponsiveBox, Text } from '@usap/uicomponents'
import { LocalContext } from '../../../helpers/useLocalContext'
import { formatBrandInText } from '../../../transformers/BrandText'
import RatingsFor from './RatingsFor'

export default function SingleReview(props) {
  const { review } = props
  const {
    productTitle,
    reviewTitle,
    purchaseDate,
    reviewDate,
    rating,
    reviewText,
    reviewerName,
    ratingsFor,
    link,
  } = review

  const { localContext } = useContext(LocalContext)
  const { Link } = localContext
  const styleMemo = useMemo(
    () => ({
      wrapperBoxBorder: { side: 'bottom', size: 'xsmall', color: 'light-3' },
      wrapperBoxMarg: { vertical: 'small' },
      boxSmallBtmMarg: { bottom: 'small' },
      boxMdBtmMarg: { bottom: 'medium' },
      reviewerBoxMarg: { right: 'small' },
      purchaseBoxMarg: { left: 'small' },
      purchaseBoxPad: {
        vertical: '1px',
        horizontal: 'medium',
      },
    }),
    [],
  )

  return (
    <Box
      border={styleMemo.wrapperBoxBorder}
      margin={styleMemo.wrapperBoxMarg}
    >
      <ResponsiveBox
        fxDirection={{ large: 'row', other: 'column' }}
        margin={styleMemo.boxSmallBtmMarg}
      >
        <ResponsiveBox
          fxWidth={{ large: '25%', other: '100%' }}
          fxPad={{ large: { right: 'small' } }}
        >
          {productTitle && (
            <Link to={link}>
              <Box margin={styleMemo.boxSmallBtmMarg}>
                <Text size="xsmall" color="brand" weight="bold">
                  {formatBrandInText(productTitle)}
                </Text>
              </Box>
            </Link>
          )}

          <Box margin={styleMemo.boxSmallBtmMarg}>
            <Text size="xsmall" color="dark-2">
              {reviewDate}
            </Text>
          </Box>

          <Box margin={styleMemo.boxSmallBtmMarg}>
            <StarCount ratings={rating} />
          </Box>

          {reviewTitle && (
            <Box>
              <Text size="medium" color="dark-2" weight="bold">
                {reviewTitle}
              </Text>
            </Box>
          )}
        </ResponsiveBox>

        <ResponsiveBox
          fxWidth={{ large: '50%', other: '100%' }}
          fxPad={{ large: { right: 'small' } }}
        >
          {reviewText && (
            <Box margin={styleMemo.boxMdBtmMarg}>
              <Text size="xsmall" color="dark-2">
                {reviewText}
              </Text>
            </Box>
          )}

          {reviewerName && (
            <Box direction="row" margin={styleMemo.boxMdBtmMarg}>
              <Box margin={styleMemo.reviewerBoxMarg}>
                <Text size="xsmall" color="dark-2">
                  {reviewerName}
                </Text>
              </Box>

              <Box
                margin={styleMemo.purchaseBoxMarg}
                background="orange"
                pad={styleMemo.purchaseBoxPad}
                round="16px"
                alignSelf="center"
              >
                <Text size="10px" color="white">
                  VERIFIED PURCHASER
                </Text>
              </Box>
            </Box>
          )}
        </ResponsiveBox>

        <ResponsiveBox fxWidth={{ large: '50%', other: '100%' }}>
          <RatingsFor ratingsFor={ratingsFor} />

          <Box margin={styleMemo.boxSmallBtmMarg}>
            <Text size="xsmall" color="dark-2">
              {`Purchased on ${purchaseDate}`}
            </Text>
          </Box>
        </ResponsiveBox>
      </ResponsiveBox>
    </Box>
  )
}
